import { inject, Injectable } from '@angular/core';
import { ApiService, Category, Food, Unit} from '@us/web/shared/data-access';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getSearchableText } from '@us/web/shared/utils';

@Injectable({
    providedIn: 'root'
})
export class CategoriesService {
    private readonly apiService = inject(ApiService);

    public getFoodMenu(shopId?: string, customer_phone?: string | null): Observable<Category[]> {
        const params = shopId ? { shop_id: shopId, customer_phone } : { customer_phone };
        return this.apiService.get('shop/food-menus', { params }).pipe(
            map(response => {
                const categories: Category[] = [];
                for (const item of response.flatMap((e: any) => e.menu_detail) as Food[]) {
                    item.units = item.units.filter((u: Unit) => !u.hidden_unit);
                    if (!item?.units.length) {
                        // eslint-disable-next-line no-continue
                        continue;
                    }

                    item.price = item.units[0].price;
                    item.old_price = item.units[0].old_price;
                    item.discount_percent = item.old_price
                        ? +(((item.old_price - item.price) / item.old_price) * 100).toFixed(2)
                        : item.discount_percent
                        ? item.discount_percent
                        : null;

                    const index = categories.findIndex(e => e.id === item.category_id);
                    if (index === -1) {
                        categories.push({
                            id: Number(item.category_id),
                            name: item.category_name || '',
                            items: [item]
                        });
                    } else {
                        categories[index].items.push(item);
                    }
                    item.search_str = getSearchableText(item.name).toLowerCase();
                }

                return categories;
            })
        );
    }
}
